/*----------------------
     FAQS
---------------------- */
Faqs = {
    init: function () {
        //DIVIDIR DIVS
        var totalDivs = $('.item-faqs').length;
        var half = Math.ceil(totalDivs / 2);
        $('.item-faqs').slice(0, half).wrapAll('<div class="item-faqs--first-group"></div>');
        $('.item-faqs').slice(half).wrapAll('<div class="item-faqs--second-group"></div>');


        $(".item-faqs__title").on("click", function () {
            var this_parent = $(this).closest(".item-faqs");
            this_parent.toggleClass("open");
        });
        $("body").on("click", function(e){
            if (!$(e.target).closest('.item-faqs').length) {
                $(".item-faqs").removeClass("open"); 
            }
        })
    }
};


$(document).ready(function () {
    Faqs.init();
});
$(document).on('shopify:section:load', function (event) {
    Faqs.init();
});